// Angular Imports
import { environment } from '@environment'
// Store Imports
import { ActionReducerMap, MetaReducer } from '@ngrx/store'
import { IGlobalState } from '@store/models'
// Reducer Imports
import { authReducer, initialAuthState } from './auth/auth.reducer'
import { uiReducer, initialUiState } from './ui/ui.reducer'
import {
	configurationsReducer,
	initialConfigurationState,
} from './configurations/configurations.reducer'

export const globalState: IGlobalState = {
	auth: initialAuthState,
	ui: initialUiState,
	configurations: initialConfigurationState,
}

export const reducers: ActionReducerMap<IGlobalState> = {
	auth: authReducer,
	ui: uiReducer,
	configurations: configurationsReducer,
}

export const metaReducers: MetaReducer<IGlobalState>[] = !environment.production ? [] : []
